<template>
  <div
    :class= "isCiudadano? 'full-width full-height background': ''"
    :style=" {backgroundImage: isCiudadano && (ciudadSelected && ciudadSelected.file != undefined && this.searchResource(this.ciudadSelected.file, 'imagen-fondo'))? 'url(' + this.searchResource(this.ciudadSelected.file, 'imagen-fondo').url +')':''}">
    <header-page :style="isCiudadano? 'display: none': ''" showCiudadSelector/>
    <div v-if="isCiudadano && this.ciudadSelected!=null" class="tituloCiudad">
      <q-img
      v-if="this.ciudadSelected.file.length >0 && this.searchResource(this.ciudadSelected.file, 'imagen-logo')"
      class="logo"
      :src="this.searchResource(this.ciudadSelected.file, 'imagen-logo').url"
      :name="this.searchResource(this.ciudadSelected.file, 'imagen-logo').url"
      style="border-radius: 50%"
      />
      {{this.ciudadSelected.name}}
    </div>
    <div class="container">
      <Breadcrumbs :visible="!isCiudadano" />
      <div :class="[isCiudadano ? 'paddingCiudadano' : '', 'row']" style="align-items: center;">
        <!--INDICES TEMÁTICOS-->
        <div class="col-md-4 col-sm-12 col-lg-4 col-xs-12 divIndicesTematicos">
          <q-img
            class="Imagen"
            :src="imgIndiceTematico"
            :name="imgIndiceTematico"
            style="border-radius: 50%"
          />
          <q-select
            class="input"
            data-cy="indice-tematico-select"
            outlined
            :options="indicesTematicosVisibles"
            option-value="id"
            option-label="name"
            v-model="indiceSelected"
            :dense="responsiveSize"
            :options-dense ="responsiveSize"
          />
        </div>
        <!--OBJETIVOS ESTRATÉGICOS-->
        <div class="col-md-4 col-sm-12 col-lg-4 col-xs-12 divObjetivos">
          <q-img
            class="Imagen"
            :src="imgObjetivo"
            :name="imgObjetivo"
            style="border-radius: 50%"
          />
          <q-select
            class="input"
            outlined
            :options="arrayObjetivos"
            option-value="id"
            option-label="name"
            v-model="objetivoSelected"
            :dense="responsiveSize"
            :options-dense ="responsiveSize"
          />
        </div>
        <div class="col-3 dBtnCSV">
          <q-btn
            v-if="!isCiudadano"
            @click="downloadCSV()"
            unelevated
            class="bPrincipal"
          >EXPORTAR CSV</q-btn>
        </div>
        <div class="col-sm-1 dBtnCSV " v-if="!isCiudadano">
          <q-btn
            flat
            icon="play_arrow"
            @click="toogleLoop()"
            :disable="allindicadores.length === 0"
          >
            <q-tooltip>Iniciar Loop</q-tooltip>
          </q-btn>
        </div>
      </div>
      <div class="row q-col-gutter-lg" v-if="indicadores.length > 0">
        <div
          class="box-container col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 col-lg-4"
          v-for="(item, k) in indicadores"
          v-bind:key="item.id + '_' + k"
        >
          <div v-if="item.tipo === undefined">
            <GraficaMunicipioIndicador
            :dataIndicador="item"
            :idRelacionAUE = "item.id"
            showLittleTag
            :datosObjetivo="item.hasOwnProperty('datoObjetivo') ? datosdatosObjetivo={datoObjetivo: item.datoObjetivo, fechaDatoObjetivo: item.fechaDatoObjetivo, unidadMedida: item.unidadMedida } : null " />
          </div>
          <div v-if="item.tipo === 'Cualitativo' || item.tipo === 'Cuantitativo'">
            <GraficaMunicipioIndicadorAUE v-if="!item.tarjetaParaObservatorio" :dataIndicador="item" showLittleTag :tipo="item.tipo" />
            <GraficaMunicipioIndicadorAUE v-if="item.tarjetaParaObservatorio" :dataIndicador="item.tarjetaParaObservatorio" showLittleTag :tipo="item.tipo" />
          </div>
        </div>
      </div>
      <div class="divNoData row" v-if="!loading && indicadores.length === 0">
        <q-card class="col-8" flat>
          No hay indicadores para los filtros seleccionados
        </q-card>
      </div>
    </div>
  </div>
</template>

<script>
import Message from '@/components/shared/mixins/Message.js';
import Resources from '@/components/shared/mixins/Resources.js';
import { QImg } from 'quasar';
import GraficaMunicipioIndicador from '@/components/Indicadores/components/GraficaMunicipioIndicador.vue';
import GraficaMunicipioIndicadorAUE from '@/components/Indicadores/components/GraficaMunicipioIndicadorAUE.vue';
import HeaderPage from '@/components/shared/HeaderPage.vue';
import * as types from '@/storeModules/NGUD/types';
import { mapGetters } from 'vuex';
import Breadcrumbs from '@/shared/breadcrumbs/Breadcrumbs.vue';
import Loading from '@/components/shared/mixins/Loading.js';
import Const from '@/components/shared/helpers/Const.js';

export default {
  mixins: [Message, Resources, Loading],
  components: {
    GraficaMunicipioIndicador,
    HeaderPage,
    QImg,
    Breadcrumbs,
    GraficaMunicipioIndicadorAUE
  },
  computed: {
    ...mapGetters({
      indicesTematicosCiudad: types.INDICE_TEMATICO_CIUDAD,
      ciudadSelected: 'NGUD/ciudadData',
      isCiudadano: 'NGUD/isCiudadano'
    })
  },
  data () {
    return {
      imgIndiceTematico: null,
      imgObjetivo: null,
      indiceSelected: null,
      objetivoSelected: null,
      indiceData: null,
      indicadores: [],
      indicesTematicosVisibles: [],
      arrayObjetivos: [],
      arrayIndices: [],
      loading: false,
      loadingIndicadores: false,
      responsiveSize: false,
      allindicadores: []
    };
  },
  created () {
    this.responsiveSize = window.innerWidth <= 640;
    this.loading = true;
    this.init();
  },
  methods: {
    downloadCSV () {
      let satelitales = false;

      if (this.indiceSelected.name === 'Todos los indicadores') {
        satelitales = true;
      } else if (this.indiceSelected.name === 'Mi Agenda urbana') {
        satelitales = false;
      }
      this.showLoading();
      this.$store.dispatch(types.ACTION_GET_CSV_INDICADOR, {
        idCiudad: this.ciudadSelected.id,
        idIndiceTematico: this.indiceSelected.id,
        idObjetivoEstrategico: this.objetivoSelected.id,
        satelitales: satelitales
      }).then(response => {
        this.hideLoading();
      }).catch(() => {
        this.hideLoading();
      });
    },
    toogleLoop () {
      this.$store.commit(types.MUTATE_SET_LOOP_INDICATORS, {
        indicadores: this.allindicadores,
        loopTime: this.ciudadSelected.loopTime
      });

      const currentIndicator = this.allindicadores[0];

      if (!currentIndicator.tipo) {
        this.$router.push({
          name: 'detalle_indicador',
          params: { idIndicador: currentIndicator.id }
        });
      } else {
        this.$router.push({
          name: 'detalle_indicador_aue',
          params: { idCiudadIndicadorAUE: currentIndicator.id, tipo: currentIndicator.tipo, nameLink: 'Observatorio de indicadores', link: '/indices-tematicos' }
        });
      }
    },

    init () {
      this.allindicadores = [];
      this.showLoading();
      this.fillSelectorIndicesTematicos();
      this.fillSelectorObjetivosEstategicos();
    },
    async fillSelectorIndicesTematicos () {
      this.showLoading();
      await this.$store.dispatch(types.ACTION_GET_ALL_INDICES_TEMATICOS).then(response => {
        let resp = [...response.data];
        this.arrayIndices = [];
        this.arrayIndices.push({ name: 'Todos los indicadores', file: [{ fileKey: 'imagen', url: require(`@/assets/img/iso-dinapsis.svg`) }] });
        this.arrayIndices.push({ name: 'Mi Agenda urbana', file: [{ fileKey: 'imagen', url: require(`@/assets/img/AUE.svg`) }] });
        resp.forEach(indice => {
          let indiceFormated = 'Índice temático ' + indice.name;
          this.arrayIndices.push({ name: indiceFormated, file: indice.file, id: indice.id });
        });
        this.indicesTematicosVisibles = this.arrayIndices;
        this.disableOptions();

        let idIndiceTematico = this.$route.params.idIndiceTematico
          ? this.$route.params.idIndiceTematico
          : null;
        if (idIndiceTematico !== 'undefined' && idIndiceTematico !== null) {
          this.selectIndice(idIndiceTematico);
        } else {
          for (let i = 0; i <= this.indicesTematicosVisibles.length; i++) {
            if (this.indicesTematicosVisibles[i].name === 'Todos los indicadores') {
              this.indiceSelected = this.indicesTematicosVisibles[i];
            }
          }
        }
        this.hideLoading();
      }).catch(() => {
        this.hideLoading();
      });
    },
    async fillSelectorObjetivosEstategicos () {
      this.showLoading();
      await this.$store.dispatch(types.ACTION_GET_ALL_AUEOBJETIVES).then(response => {
        this.arrayObjetivos = [];
        this.arrayObjetivos.push({ name: 'Todos los Objetivos estratégicos', file: [{ fileKey: 'imagen', url: require(`@/assets/img/AUE.svg`) }] });
        this.objetivoSelected = this.arrayObjetivos[0];
        response.data.forEach(objetivo => {
          let objetivoFormated = objetivo.prefix + ': ' + objetivo.name;
          this.arrayObjetivos.push({ name: objetivoFormated, file: objetivo.file, id: objetivo.id });
        });
        this.hideLoading();
      }).catch(() => {
        this.hideLoading();
      });
    },
    getFirstIndice () {
      if (this.indicesTematicosCiudad.length === 0 || this.indicesTematicosVisibles.length === 0) return this.notHavePermissions();

      return this.indicesTematicosCiudad[0];
    },
    async loadIndicadorData (indice) {
      if (indice.id !== undefined) {
        this.indiceData = await this.$store.dispatch(
          types.ACTION_GET_INDICE_TEMATICO,
          { idIndiceTematico: indice.id }
        );
        this.imgIndiceTematico = this.getImg(this.indiceData.file);
      }
      let idObjetivoEstrategico = this.objetivoSelected !== null && this.objetivoSelected !== undefined ? this.objetivoSelected.id : undefined;
      this.getIndicadores(indice, idObjetivoEstrategico);
      this.imgIndiceTematico = this.getImg(indice.file);
    },
    loadObjetivo (objetivo) {
      // sacar la imagen del objetivo
      this.imgObjetivo = this.getImg(objetivo.file);
      let idObjetivoSelected = this.objetivoSelected !== null && this.objetivoSelected.id !== undefined ? this.objetivoSelected.id : undefined;
      let indiceSelected = this.indiceSelected !== null && this.indiceSelected !== undefined ? this.indiceSelected : undefined;
      this.getIndicadores(indiceSelected, idObjetivoSelected);
    },
    getIndicadores (indice, idObjetivo) {
      if (indice !== undefined) {
        this.showLoading();
        this.indicadores = [];
        if (!this.loadingIndicadores) {
          this.loadingIndicadores = true;
          if (indice.name === 'Todos los indicadores') {
            this.getAllIndicadores(idObjetivo, true);
          } else if (indice.name === 'Mi Agenda urbana') {
            this.getIndicadoresAUECiudad(idObjetivo);
          } else {
            this.getIndicadoresIndiceCiudad(indice.id, idObjetivo);
          }
        }
      }
    },
    async getIndicadoresIndiceCiudad (idIndice, idObjetivo) {
      if (this.ciudadSelected !== null) {
        await this.$store.dispatch(types.ACTION_GET_INDICADOR_INDICE_CIUDAD, {
          idCiudad: this.ciudadSelected.id,
          idIndiceTematico: idIndice,
          idObjetivoEstrategico: idObjetivo
        }).then(response => {
          this.indicadores = response.data;
          this.hideLoading();
          this.loading = false;
          this.loadingIndicadores = false;
          this.allindicadores = this.indicadores;
        }).catch(() => {
          this.hideLoading();
          this.loading = false;
          this.loadingIndicadores = false;
        });
      }
    },
    async getAllIndicadores (idObjetivo, satelitales = false) {
      if (this.ciudadSelected !== null) {
        await this.$store.dispatch(types.ACTION_GET_ALL_INDICADORES_OBSERVATORIO, {
          idCiudad: this.ciudadSelected.id,
          satelitales: satelitales,
          idObjetivoEstrategico: idObjetivo
        }).then(response => {
          this.indicadores = response.data;
          this.hideLoading();
          this.loading = false;
          this.loadingIndicadores = false;
          this.allindicadores = this.indicadores;
        }).catch(() => {
          this.hideLoading();
          this.loading = false;
          this.loadingIndicadores = false;
        });
      }
    },
    async getIndicadoresAUECiudad (idObjetivo) {
      if (this.ciudadSelected !== null) {
        await this.$store.dispatch(types.ACTION_GET_INDICADORESAUE_CIUDAD, {
          idCiudad: this.ciudadSelected.id,
          idObjetivoEstrategico: idObjetivo
        }).then(response => {
          this.indicadores = response.data;
          this.hideLoading();
          this.loadingIndicadores = false;
          this.loading = false;
          this.allindicadores = this.indicadores;
        }).catch(() => {
          this.hideLoading();
          this.loadingIndicadores = false;
          this.loading = false;
        });
      }
    },
    getImg (fileArray) {
      let res = this.searchResource(fileArray, 'imagen');

      return res ? res.url : this.getDefaultResource('imagen');
    },
    selectIndice (idIndice) {
      this.indiceSelected = this.existIndiceTematicoCiudad(idIndice) ? this.indicesTematicosVisibles.find(e => e.id === idIndice) : this.notHavePermissions();
    },
    existIndiceTematicoCiudad (idIndice) {
      return this.indicesTematicosCiudad.find((e) => e === idIndice);
    },
    disableOptions () {
      this.indicesTematicosVisibles.forEach((e, i) => {
        this.indicesTematicosVisibles[i].disable = true;
        if (this.indicesTematicosVisibles[i].name === 'Todos los indicadores') {
          this.indicesTematicosVisibles[i].disable = false;
        }
        if (this.indicesTematicosVisibles[i].name === 'Mi Agenda urbana' && this.ciudadSelected.indices.indexOf(Const.ID_AUE) !== -1) {
          this.indicesTematicosVisibles[i].disable = false;
        }
      });
      let indicesCiudad = this.indicesTematicosVisibles.filter((i) => this.indicesTematicosCiudad.indexOf(i.id) !== -1);
      if (indicesCiudad.length === 0) return;

      indicesCiudad.map((e) => {
        let posArray = this.indicesTematicosVisibles.findIndex((element) => element.id === e.id);
        this.indicesTematicosVisibles[posArray].disable = false;
      });
    },
    notHavePermissions () {
      this.showError('No dispone de este índice temático');
      this.$router.push({
        name: 'DefaultInicio'
      });
    }
  },
  watch: {
    ciudadSelected () {
      this.init();
    },
    indiceSelected: {
      handler: function (val) {
        if (!val) return;
        // Reload Indicadores
        this.loading = true;
        this.$router.replace({
          name: 'indices-tematicos',
          params: { idIndiceTematico: `${val.id}` },
          query: this.$route.query
        }).catch(() => {});
        this.loadIndicadorData(val);
      },
      deep: true
    },
    objetivoSelected: {
      handler: function (val) {
        this.loading = true;
        if (!val) return;
        this.loadObjetivo(val);
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
}
.input {
  background-color: #fff;
  border-radius: 10px;
}

.box-container {
  margin-top: 20px;
}

a {
  text-decoration: none;
  color: inherit;
}
.txt-return {
  padding-left: 8px;
  object-fit: contain;
  background-color: white;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.36px;
  text-align: center;
  color: $azulcabecera;
  font-family: "DINPro";
}
.action-button {
  padding-top: 30px;
}
.bPrincipal{
  float: right;
}
.Imagen{
  float: left;
  margin-right: 12px;
  background-color: white;
}
.dBtnCSV{
  align-self: end;
}
.divIndicesTematicos{
  padding-right: 20px;
}
.divNoData {
  margin-top: 35px;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  font-family: "DINPro";
  color: #313b44;
}
.col-md-4.col-xs-12 > .q-img {
  height: 60px;
  width: 60px;
}
.paddingCiudadano{
  padding-top: 15px;
}
.tituloCiudad {
  font-family: DINPro;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #002f6c;
  padding: 25px;
}
.logo{
    height: 60px;
    width: 60px;
    margin-right: 12px;
  }
@media (max-width: 992px) {
   ::v-deep {
    .divIndicesTematicos {
      padding-right: 0px;
    }
    .col-md-4.col-xs-12 {
      margin-bottom: 15px;
    }
   }
}

@media (max-width: 640px) {
  ::v-deep {
    .col-md-4.col-xs-12 > .q-img {
      height: 45px;
      width: 45px;
    }
    .col-md-4.col-xs-12 {
      margin-bottom: 15px;
    }
    .q-card.container-indicador.shadow-1 {
      padding: 15px 15px 15px 15px;
      height: auto !important;
      min-height: 0px !important;
    }
    .chart {
      height: 100px !important;
    }
    .container {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  .tituloCiudad {
    padding: 10px;
  }
  .logo{
    height: 45px;
    width: 45px;
    margin-right: 12px;
  }
}
.background {
  background-repeat: no-repeat;
  background-size: auto 70vh;
  background-position-x: center;
  background-position-y: bottom;
  background-size: cover;
  background-color: rgba(255,255,255,0.4);
  background-blend-mode: lighten;
}
</style>
